import { createSlice, PayloadAction } from '@reduxjs/toolkit'
type SnackbarSeverity = 'success' | 'info' | 'warning' | 'error'
interface SnackbarState {
  messages: Array<{
    message: string
    severity: SnackbarSeverity
  }>
}

const initialState: SnackbarState = {
  messages: [] as Array<{
    message: string
    severity: SnackbarSeverity
  }>,
}

const snackbarSlice = createSlice({
  name: 'snackbar',
  initialState,
  reducers: {
    showSnackbar: (
      state,
      action: PayloadAction<{
        message: string
        severity: SnackbarSeverity
      }>,
    ) => {
      if (!state.messages) {
        state.messages = []
      }
      state.messages.push(action.payload)
    },
    clearSnackbar: (state) => {
      state.messages = []
    },
    removeSnackbar: (state, action: PayloadAction<number>) => {
      if (state.messages) {
        state.messages.splice(action.payload, 1)
      }
    },
  },
})

export type { SnackbarState }
export const { showSnackbar, clearSnackbar, removeSnackbar } =
  snackbarSlice.actions
export default snackbarSlice.reducer
